module.exports = __webpack_public_path__ + "static/img/17a.2713839.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/17a.jpg
// module id = 6W2d
// module chunks = 1